<template>
  <div class="d-flex flex-wrap align-center acoes-envio">
    <v-btn
      v-if="canVer && temResposta"
      small
      outlined
      color="primary"
      @click.stop="$emit('ver', item)"
    >
      <v-icon left small>mdi-eye</v-icon>{{ $t('contractTemplate.answer.view') }}
    </v-btn>
    <!-- span com .stop: o clique no menu não pode chegar à linha da tabela. -->
    <span v-if="canBaixar" @click.stop>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small outlined color="green darken-1" v-bind="attrs" v-on="on">
            <v-icon left small>mdi-download</v-icon>{{ $t('contractTemplate.send.download') }}
            <v-icon right small>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="$emit('baixar', item, 'xlsx')">
            <v-list-item-icon><v-icon small color="green">mdi-microsoft-excel</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('contractTemplate.send.formatXlsx') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$emit('baixar', item, 'csv')">
            <v-list-item-icon><v-icon small color="primary">mdi-file-delimited-outline</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('contractTemplate.send.formatCsv') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </span>
    <v-btn
      v-if="canImportar && item.status !== 'CANCELADO'"
      small
      outlined
      color="primary"
      :disabled="importando"
      @click.stop="$emit('importar', item)"
    >
      <v-icon left small>mdi-file-upload-outline</v-icon>{{ $t('contractTemplate.send.importShort') }}
    </v-btn>
    <slot></slot>
  </div>
</template>

<script>
/**
 * Ações sobre a resposta de um envio de template de contrato, iguais no
 * diálogo de envios e no de respostas: ver a resposta, baixar a planilha
 * (escolhendo Excel ou CSV) e importar a planilha devolvida pelo cliente.
 * O slot recebe as ações próprias de cada diálogo (cancelar, criar contrato).
 */
export default {
  name: 'EnvioTemplateAcoes',
  props: {
    item: { type: Object, required: true },
    canVer: { type: Boolean, default: false },
    canBaixar: { type: Boolean, default: false },
    canImportar: { type: Boolean, default: false },
    importando: { type: Boolean, default: false },
  },
  computed: {
    temResposta() {
      return ['EM_PREENCHIMENTO', 'PREENCHIDO'].includes(this.item.status);
    },
  },
};
</script>

<style scoped>
.acoes-envio {
  gap: 6px;
  padding: 4px 0;
}
</style>
